import { render, staticRenderFns } from "./ConsultantsProfiles.vue?vue&type=template&id=3a299d70&scoped=true"
import script from "./ConsultantsProfiles.vue?vue&type=script&lang=js"
export * from "./ConsultantsProfiles.vue?vue&type=script&lang=js"
import style0 from "./ConsultantsProfiles.vue?vue&type=style&index=0&id=3a299d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a299d70",
  null
  
)

export default component.exports